import * as tslib_1 from "tslib";
import { VuexModule, Module, Mutation, Action, getModule, } from "vuex-module-decorators";
import store from "@/store";
import { fetchPaperDetail } from "@/api/test-paper";
import { getQuestionDetail } from "@/api/question";
const formatQuestions = (quesList) => {
    const newQuesList = quesList.map((ques) => {
        if (ques.type == 6 && ques.subQuestionList) {
            ques.subQuestionList = formatQuestions(ques.subQuestionList);
            // ques.subQuestionList.forEach(sub => {
            //   sub.isMaterialQuestion = true
            // });
        }
        let score = ques.score || 2;
        if (ques.type == 4) {
            ques.everyBlankScore = ques.everyBlankScore || 2;
            score = Number(ques.everyBlankScore) * ques.optionList.length;
        }
        else if (ques.type == 6) {
            score = 0;
            ques.subQuestionList && ques.subQuestionList.forEach((q) => {
                score += q.score;
            });
        }
        const newQues = {
            ...ques,
            typeStr: formatQuestionType(ques.type),
            score: score,
        };
        if ((ques.type == 1 || ques.type == 5) && ques.omitType) {
            newQues.omitScore = ques.omitScore;
            newQues.omitType = ques.omitType;
        }
        else {
            newQues.omitScore = 0;
            newQues.omitType = -1;
        }
        return newQues;
    });
    // console.log(newQuesList, "处理后的题目列表新的")
    return newQuesList;
};
const formatQuestionType = (e) => {
    switch (e) {
        case 0:
            return "单选";
        case 1:
            return "多选";
        case 2:
            return "问答";
        case 3:
            return "判断";
        case 4:
            return "填空";
        // case 5:
        //   return "不定项选择题";
        case 6:
            return "材料题";
        default:
            return "";
    }
};
const updateQuestionScore = (originQues, sourceQues) => {
    if (4 == sourceQues.type) {
        sourceQues.everyBlankScore = originQues.everyBlankScore || 2;
        sourceQues.score = sourceQues.everyBlankScore * sourceQues.optionList.length;
    }
    else if (6 == sourceQues.type) {
        const _map = {};
        originQues.subQuestionList.forEach((q) => {
            _map[q.type] = q;
        });
        console.log(_map, "preChildMappreChildMap");
        let _score = 0;
        sourceQues.subQuestionList.forEach((q) => {
            if (_map[q.type]) {
                updateQuestionScore(_map[q.type], q);
            }
            else {
                updateQuestionScore({}, q);
            }
            _score += q.score;
        });
        sourceQues.score = _score;
    }
    else {
        sourceQues.score = originQues.score ? originQues.score : 2;
    }
};
let TestPaperEditor = class TestPaperEditor extends VuexModule {
    constructor() {
        super(...arguments);
        // --------------------State--------------------
        this._baseInfo = {
            paperId: "",
            paperTitle: "",
            paperLibraryId: "",
            paperLibraryName: "",
            // option_disorder: 0,
            // question_disorder: 0,
            // question_random: 0,
            // ran_details: [],
            questionList: [],
            participateCount: 0,
            ruleList: [],
        };
        this._gloableLoading = false;
    }
    // --------------------Getters--------------------
    get baseInfo() {
        return this._baseInfo;
    }
    get paperId() {
        return this._baseInfo.paperId;
    }
    get paperTitle() {
        return this._baseInfo.paperTitle;
    }
    get paperLibraryId() {
        return this._baseInfo.paperLibraryId;
    }
    get paperlibraryName() {
        return this._baseInfo.paperLibraryName;
    }
    get questionList() {
        return this._baseInfo.questionList;
    }
    get gloableLoading() {
        return this._gloableLoading;
    }
    // get ranDetails() {
    //   return this._baseInfo.ran_details
    // }
    // --------------------Mutation--------------------
    INIT_PAPER_ID(paperId) {
        this._baseInfo.paperId = paperId;
    }
    INIT_PAPER_TITLE(paperTitle) {
        this._baseInfo.paperTitle = paperTitle;
    }
    INIT_PAPER_LIB_ID(libraryId) {
        this._baseInfo.paperLibraryId = libraryId;
    }
    INIT_PAPER_LIB_NAME(libraryName) {
        this._baseInfo.paperLibraryName = libraryName;
    }
    // @Mutation
    // private INIT_QUESTION_RANDOM(questionRandom: number) {
    //   this._baseInfo.question_random = questionRandom
    // }
    // @Mutation
    // private INIT_OPTION_DISORDER(optionDisorder: number) {
    //   this._baseInfo.option_disorder = optionDisorder
    // }
    // @Mutation
    // private INIT_QUESTION_DISORDER(questionDisorder: number) {
    //   this._baseInfo.question_disorder = questionDisorder
    // }
    // @Mutation
    // private INIT_RAN_DETAILS(randomDetails: any[]) {
    //   this._baseInfo.ran_details = randomDetails
    // }
    INIT_QUESTION_LIST(quesList) {
        this._baseInfo.questionList = quesList;
    }
    INIT_PARTICIPATE_COUNT(participateCount) {
        this._baseInfo.participateCount = participateCount;
    }
    INIT_PAPER_BASE_INFO(baseInfo) {
        this._baseInfo = baseInfo;
    }
    INIT_RULE_LIST(ruleList) {
        this._baseInfo.ruleList = ruleList;
    }
    // @Mutation
    // private INIT_RANDOM_TOTAL_SCORE(randomTotalScore: number) {
    //   this._baseInfo.randomTotalScore = randomTotalScore
    // }
    // @Mutation
    // private INIT_RANDOM_TOTAL_NUMBER(randomTotalNumber: number) {
    //   this._baseInfo.randomTotalNum = randomTotalNumber
    // }
    INIT_GLOABLE_LOADING(loading) {
        this._gloableLoading = loading;
    }
    RESET_STATE() {
        this._baseInfo = {
            paperId: "",
            paperTitle: "",
            paperLibraryId: "",
            paperLibraryName: "",
            // option_disorder: 0,
            // question_disorder: 0,
            // question_random: 0,
            // ran_details: [],
            questionList: [],
            participateCount: 0,
            ruleList: [],
        };
        this._gloableLoading = false;
    }
    // --------------------Action--------------------
    resetState() {
        return;
    }
    setPaperBaseInfo(baseInfo) {
        return baseInfo;
    }
    setPaperId(paperId) {
        return paperId;
    }
    setRuleList(ruleList) {
        let score = 0, count = 0;
        // if (this.baseInfo.ruleList.length) {
        //   const _ruleList = JSON.parse(JSON.stringify(this.baseInfo.ruleList));
        //   if (this.baseInfo.question_random === 1) {
        //     ruleList.forEach((rule) => {
        //       _ruleList.forEach((_rule) => {
        //         if (rule.type == _rule.type) {
        //           rule.selectedNum = rule.selectedNum ? rule.selectedNum : _rule.selectedNum
        //         }
        //       })
        //     })
        //   }
        // }
        this.context.commit("INIT_RULE_LIST", ruleList);
        // ruleList.forEach((rule) => {
        //   score += rule.selectedNum * rule.questionScore
        //   count += Number(rule.selectedNum)
        // })
        // score = 10 * Number(score.toFixed(1)) / 10
        // this.context.commit("INIT_RANDOM_TOTAL_NUMBER", count)
        // this.context.commit("INIT_RANDOM_TOTAL_SCORE", score)
    }
    // @Action({ commit: "INIT_QUESTION_RANDOM" })
    // public setQuestionRandom(questionRandom: number) {
    //   return questionRandom
    // }
    // @Action({ commit: "INIT_OPTION_DISORDER" })
    // public setOptionDisorder(optionDisorder: number) {
    //   return optionDisorder
    // }
    // @Action({ commit: "INIT_QUESTION_DISORDER" })
    // public setQuestionDisorder(questionDisorder: number) {
    //   return questionDisorder
    // }
    // @Action({ commit: "INIT_RAN_DETAILS" })
    // public setRanDetails(randomDetails: any[]) {
    //   return randomDetails
    // }
    setQuestionList(quesList) {
        return quesList;
    }
    moveUp(index) {
        const quesList = JSON.parse(JSON.stringify(this.baseInfo.questionList));
        quesList.splice(index - 1, 0, ...quesList.splice(index, 1));
        return quesList;
    }
    moveDown(index) {
        const quesList = JSON.parse(JSON.stringify(this.baseInfo.questionList));
        quesList.splice(index + 1, 0, ...quesList.splice(index, 1));
        return quesList;
    }
    moveTop(index) {
        const quesList = JSON.parse(JSON.stringify(this.baseInfo.questionList));
        quesList.unshift(...quesList.splice(index, 1));
        return quesList;
    }
    singleDeleteQuestion(index) {
        const quesList = JSON.parse(JSON.stringify(this.baseInfo.questionList));
        quesList.splice(index, 1);
        return quesList;
    }
    multiDeleteQuestion(type) {
        let quesList = JSON.parse(JSON.stringify(this.baseInfo.questionList));
        quesList = quesList.filter((ques) => ques.type != type);
        return quesList;
    }
    handleQuestionsParams(params) {
        const mode = params.type;
        const list = params.list;
        let quesList = [];
        if ("concat" == mode) {
            const _quesList = JSON.parse(JSON.stringify(this.baseInfo.questionList));
            quesList = _quesList.concat(formatQuestions(list));
            // console.log(quesList, "添加题目处理后的样子")
        }
        else {
            quesList = formatQuestions(list);
        }
        return quesList;
    }
    async getPaperDetail(paperId) {
        this.context.commit('INIT_GLOABLE_LOADING', true);
        try {
            const res = await fetchPaperDetail(paperId);
            const data = res.data.data;
            this.context.commit('INIT_PAPER_ID', data.id);
            this.context.commit('INIT_PAPER_TITLE', data.title);
            this.context.commit('INIT_PAPER_LIB_ID', data.categoryId);
            this.context.commit('INIT_PAPER_LIB_NAME', data.categoryName);
            // this.context.commit('INIT_QUESTION_DISORDER', data.question_disorder)
            // this.context.commit('INIT_OPTION_DISORDER', data.option_disorder)
            // this.context.commit('INIT_QUESTION_RANDOM', data.question_random)
            // const randomDetails = data.ran_details || []
            // this.context.commit('INIT_RAN_DETAILS', randomDetails)
            let questionList = data.questionList || [];
            const participateCount = data.bindExamTotal;
            const questionTypeList = [
                {
                    questionTypeText: "单选",
                    type: 0,
                    num: 0,
                    pointStatusArr: []
                },
                {
                    questionTypeText: "多选",
                    type: 1,
                    num: 0,
                    pointStatusArr: []
                },
                {
                    questionTypeText: "判断",
                    type: 3,
                    num: 0,
                    pointStatusArr: []
                },
                {
                    questionTypeText: "填空",
                    type: 4,
                    num: 0,
                    pointStatusArr: []
                },
                {
                    questionTypeText: "问答",
                    type: 2,
                    num: 0,
                    pointStatusArr: []
                },
                // {
                //   questionTypeText: "不定项选择",
                //   type: 5,
                //   num: 0,
                //   pointStatusArr: []
                // },
                {
                    questionTypeText: "材料",
                    type: 6,
                    num: 0,
                    pointStatusArr: []
                }
            ];
            questionList.forEach((ques) => {
                const type = questionTypeList.find((item) => item.type === ques.type);
                type.num++;
                type.pointStatusArr.push({
                    type: ques.type,
                    answer: ques.correct_answer,
                    id: ques.id,
                    score: ques.score,
                    everyBlankScore: ques.type === 4 ? ques.everyBlankScore : ques.score,
                    omitScore: ques.omitScore,
                    omitType: ques.omitType
                });
            });
            let ruleList = [];
            questionTypeList.forEach((type) => {
                if (type.num > 0) {
                    const isDifferentScore = type.pointStatusArr.some((ques, _, arr) => ques.score !== arr[0].score);
                    const rule = {
                        availableNum: type.num,
                        type: type.type,
                        selectedNum: 0,
                        isDifferentScore,
                        questionScore: 0
                    };
                    if (!rule.isDifferentScore) {
                        rule.questionScore = type.pointStatusArr[0].score;
                    }
                    ruleList.push(rule);
                }
            });
            // ruleList.forEach((rule) => {
            //   const detail = randomDetails.find(d => rule.type == d.type)
            //   if (detail) rule.selectedNum = detail.num
            // })
            // if (randomDetails.length > 0) {
            //   const _ruleList = []
            //   randomDetails.forEach((detail) => {
            //     const rule = ruleList.find(r => detail.type == r.type)
            //     if (rule) _ruleList.push(rule)
            //   }
            //   )
            //   ruleList = _ruleList
            // }
            this.setRuleList(ruleList);
            questionList = formatQuestions(questionList);
            this.context.commit('INIT_QUESTION_LIST', questionList);
            this.context.commit('INIT_PARTICIPATE_COUNT', participateCount);
        }
        catch (_) {
            console.error(_);
        }
        finally {
            this.context.commit('INIT_GLOABLE_LOADING', false);
        }
    }
    async updateEditQuestion(questionId) {
        this.context.commit('INIT_GLOABLE_LOADING', true);
        try {
            const res = await getQuestionDetail(questionId);
            const info = res.data.data;
            let m = 0;
            let quesList = JSON.parse(JSON.stringify(this.baseInfo.questionList));
            const _quesIndex = quesList.findIndex((q) => q.id == info.id);
            if (_quesIndex > -1) {
                console.log("更新对应的题目信息");
                m = _quesIndex;
                updateQuestionScore(quesList[_quesIndex], info);
            }
            console.log(info, "更改题目后modifyQuestion");
            quesList.splice(m, 1, info);
            quesList = formatQuestions(quesList);
            console.log(quesList, "更改题目后questionsListquestionsList");
            this.context.commit('INIT_QUESTION_LIST', quesList);
        }
        catch (_) { }
        finally {
            this.context.commit('INIT_GLOABLE_LOADING', false);
        }
    }
};
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_PAPER_ID", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_PAPER_TITLE", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_PAPER_LIB_ID", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_PAPER_LIB_NAME", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_QUESTION_LIST", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_PARTICIPATE_COUNT", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_PAPER_BASE_INFO", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_RULE_LIST", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "INIT_GLOABLE_LOADING", null);
tslib_1.__decorate([
    Mutation
], TestPaperEditor.prototype, "RESET_STATE", null);
tslib_1.__decorate([
    Action({ commit: "RESET_STATE" })
], TestPaperEditor.prototype, "resetState", null);
tslib_1.__decorate([
    Action({ commit: "INIT_PAPER_BASE_INFO" })
], TestPaperEditor.prototype, "setPaperBaseInfo", null);
tslib_1.__decorate([
    Action({ commit: "INIT_PAPER_ID" })
], TestPaperEditor.prototype, "setPaperId", null);
tslib_1.__decorate([
    Action
], TestPaperEditor.prototype, "setRuleList", null);
tslib_1.__decorate([
    Action({ commit: "INIT_QUESTION_LIST" })
], TestPaperEditor.prototype, "setQuestionList", null);
tslib_1.__decorate([
    Action({ commit: "INIT_QUESTION_LIST" })
], TestPaperEditor.prototype, "moveUp", null);
tslib_1.__decorate([
    Action({ commit: "INIT_QUESTION_LIST" })
], TestPaperEditor.prototype, "moveDown", null);
tslib_1.__decorate([
    Action({ commit: "INIT_QUESTION_LIST" })
], TestPaperEditor.prototype, "moveTop", null);
tslib_1.__decorate([
    Action({ commit: "INIT_QUESTION_LIST" })
], TestPaperEditor.prototype, "singleDeleteQuestion", null);
tslib_1.__decorate([
    Action({ commit: "INIT_QUESTION_LIST" })
], TestPaperEditor.prototype, "multiDeleteQuestion", null);
tslib_1.__decorate([
    Action({ commit: "INIT_QUESTION_LIST" })
], TestPaperEditor.prototype, "handleQuestionsParams", null);
tslib_1.__decorate([
    Action
], TestPaperEditor.prototype, "getPaperDetail", null);
tslib_1.__decorate([
    Action
], TestPaperEditor.prototype, "updateEditQuestion", null);
TestPaperEditor = tslib_1.__decorate([
    Module({ dynamic: true, store, name: "TestPaperEdit" })
], TestPaperEditor);
export const TestPaperEditorModule = getModule(TestPaperEditor);
